export default {
  all: [
    {
      label: 'New',
      value: 'not-started'
    },
    {
      label: 'Open',
      value: 'in-progress'
    },
    {
      label: 'Hold',
      value: 'on-hold'
    },
    {
      label: 'Deferred',
      value: 'deferred'
    },
    {
      label: 'Completed',
      value: 'completed'
    },
    {
      label: 'Cancelled',
      value: 'cancelled'
    }
  ],
  current: [
    {
      label: 'New',
      value: 'not-started'
    },
    {
      label: 'Open',
      value: 'in-progress'
    },
    {
      label: 'Hold',
      value: 'on-hold'
    }
  ],
  defaultAssignee: [
    {
      label: 'Open',
      value: 'in-progress'
    },
    {
      label: 'Hold',
      value: 'on-hold'
    },
    {
      label: 'Deferred',
      value: 'deferred'
    },
    {
      label: 'Completed',
      value: 'completed'
    },
    {
      label: 'Cancelled',
      value: 'cancelled'
    }
  ],
  differentAssignee: [{
    label: 'New',
    value: 'not-started'
  }],
  mapAll: [
    {
      label: 'NEW',
      value: 'not-started'
    },
    {
      label: 'OPEN',
      value: 'in-progress'
    },
    {
      label: 'HOLD',
      value: 'on-hold'
    },
    {
      label: 'DFRD',
      value: 'deferred'
    },
    {
      label: 'CMPL',
      value: 'completed'
    },
    {
      label: 'CNCL',
      value: 'cancelled'
    }
  ]
}
